(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Scroll reveal for product cards
  document.addEventListener('DOMContentLoaded', function () {
    const cards = document.querySelectorAll('.product-grid__item');

    if (!cards.length) return;

    // No IntersectionObserver support → just show everything
    if (!('IntersectionObserver' in window)) {
      cards.forEach((card) => card.classList.add('gl-card-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('gl-card-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2
      }
    );

    cards.forEach((card) => {
      card.classList.add('gl-card-animate');
      observer.observe(card);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var cards = document.querySelectorAll('.section-wrapper .group-block-content');

    if (!cards.length) return;

    // Fallback for very old browsers
    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        card.classList.add('scroll-fade-card', 'is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.25
    });

    cards.forEach(function (card) {
      card.classList.add('scroll-fade-card');
      observer.observe(card);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
